"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRelativePosition = void 0;
/**
 *
 * Calculates the absolute positional properties (left, top, right, bottom) of
 * a given element relative to one of its parent elements.
 *
 * You would think there would be an easy built-in way to do this in Javascript, but there is not : (
 *
 * This is useful for determining the starting keyframe when animating an element,
 * since there must always be property overlap when animating absolutely positioned elements.
 *
 * i.e. you cannot animate {left: 20px, top: 20px} to {right: 20px, bottom: 20px},
 * but you CAN animate {right: 200px, bottom: 200px} to {right: 20px, bottom: 20px}.
 * In that case, this function would provide the right/bottom position values given a starting position of {left: 20px, top: 20px},
 * allowing you to animate the element absolutely in any direction from its initial position.
 *
 * @param element
 * @param referenceElement
 */
function getRelativePosition(element, referenceElement) {
    const { left: parentLeft, top: parentTop, bottom: parentBottom, right: parentRight, } = referenceElement.getBoundingClientRect();
    const { height, width, 
    // absolute distance from LEFT edge of target to left window edge
    left: elementLeft, 
    // absolute distance from TOP of target element to top of window
    top: elementTop, 
    // absolute distance from BOTTOM of target element to top of window
    right: elementRight, 
    // absolute distance from RIGHT edge of target to left window edge
    bottom: elementBottom, } = element.getBoundingClientRect();
    // distance from parent to LEFT outer side of element
    const relativeLeft = elementLeft - parentLeft;
    // distance from parent to TOP outer side of element
    const relativeTop = elementTop - parentTop;
    // distance from parent to BOTTOM outer side of element
    const relativeBottom = parentBottom - elementBottom;
    // distance from parent to RIGHT outer side of element
    const relativeRight = parentRight - elementRight;
    const relativePosition = {
        left: relativeLeft,
        right: relativeRight,
        bottom: relativeBottom,
        top: relativeTop,
        height,
        width,
    };
    return relativePosition;
}
exports.getRelativePosition = getRelativePosition;
//# sourceMappingURL=utils.js.map